export const defaultLanguage = 'alt1';

export const menuRenderInitialState = {
  browserItemsSelections: {},
  browserItemsOrder: {},
  selectedLanguage: defaultLanguage,
  selectedZoneOfConsume: '',
  prices: {},
  userDefinedData: {},
  ticket: {},
  subdomain: '',
  saleLocationGuid: '',
  status: '',
  currencySymbol: '',
  currencyPosition: '',
  showFeatures: false,
  scrollBrowserSelected: {},
  clauseGuidWithSectionsGuid: {},
  showIconFeatures: false,
  showProductTags: false,
  showIconProductTags: false,
  shopList: {},
  tableGuid: ''
};
